export default __webpack_public_path__ + "static/media/icon-hospitalizacion.be73e8ab.svg";